<template>
  <div :class="`ims-coin size-${size}`">
    <span>{{value}}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: null
    },
    size: {
      default: "md"
    }
  }
};
</script>

<style lang="scss">
$sm: 40px;
$md: 48px;
$lg: 64px;

.ims-coin {
  height: $md;
  width: $md;
  border-radius: $md * 0.5;
  //background-color: #f5ce00;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  text-shadow: 0px -1px 0px rgba(255, 255, 255, 0.5);
  color: #000;
  //box-shadow: 0px 2px 0px #e27a03, 0px 5px 5px rgba(0, 0, 0, 0.27);
  //border: solid 1px rgba(255, 255, 255, 0.4);
  position: relative;

  border: 0.5px solid #CCCCCC;
  background:radial-gradient(50% 50% at 50% 50%, #EEEEEE 100%, #CECECE 100%);
  text-shadow: 0px -1px 0px rgba(255, 255, 255, 0.5);
  box-shadow:0px 5px 5px rgba(0, 0, 0, 0.1);

  span{ position:relative; z-index:2; }

  &:before {
    content: "";
    width: 92%;
    height: 92%;
    position: absolute;

    border-radius: 50%;
    //box-shadow: inset 0px 2px 2px rgba(0, 0, 0, 0.1);

    background:radial-gradient(50% 50% at 50% 50%, #EEEEEE 36.46%, #DDDDDD 100%);
    border: 0.5px solid #EFEFEF;
    box-shadow:inset 0px 2px 2px rgba(51, 51, 51, 0.25);
  }
  &:after {
    position: absolute;
    bottom: 5px;
    left: 0;
    right: 0;
    content: "pts";
    font-size: 60%;
    text-align: center;
    opacity: 0.5;
  }

  &.size-sm {
    height: $sm;
    width: $sm;
    border-radius: $sm * 0.5;
    font-size: 10px;
    margin: 2px;
    &:after {
      display: none;
    }
  }
  &.size-md {
    height: $md;
    width: $md;
    border-radius: $md * 0.5;
    font-size: 13px;
    margin: 4px;
  }
  &.size-lg {
    height: $lg;
    width: $lg;
    border-radius: $lg * 0.5;
    font-size: 19px;
    margin: 6px;
  }
}
</style>